/* 99 - story layer v7 (works alongside the99-custom.js) */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* start the hero entrances when the intro loader lifts (or right away when it is skipped) */
  function go() { root.classList.add('x99-go'); }
  (function syncLoader() {
    var ld = document.getElementById('g99-loader');
    if (!ld || root.classList.contains('x99-no-intro') || ld.classList.contains('g99-done')) { go(); return; }
    var mo = new MutationObserver(function () {
      if (ld.classList.contains('g99-done')) { mo.disconnect(); go(); }
    });
    mo.observe(ld, { attributes: true, attributeFilter: ['class'] });
    setTimeout(go, 5000);
  })();

  /* Phones: choose Shopify's 720p MP4 rendition (480p on slow links / data saver) from the HLS
     master playlist, e.g. "<id>.HD-720p.4.5Mbps.hls.97635099_.m3u8" -> "<id>.HD-720p-4.5Mbps-97635099.mp4". */
  function pickMobileSource(v) {
    var c = navigator.connection || {};
    var slow = c.saveData || /(^|-)2g|3g/.test(c.effectiveType || '');
    var want = slow ? 480 : 720;
    function use(url) {
      if (!url) return;
      v.src = url;
      if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    if (!v.dataset.hls || !window.fetch) { use(v.dataset.mp4); return; }
    fetch(v.dataset.hls).then(function (r) { return r.ok ? r.text() : Promise.reject(); }).then(function (txt) {
      var best = null;
      txt.split('\n').forEach(function (line) {
        var m = line.trim().split('?')[0].match(/^(.+)\.(HD|SD)-(\d+)p\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/);
        if (!m) return;
        var h = +m[3];
        if (h <= want && (!best || h > best.h)) best = { h: h, name: m[1] + '.' + m[2] + '-' + m[3] + 'p-' + m[4] + '-' + m[5] + '.mp4' };
      });
      use(best ? new URL(best.name, new URL(v.dataset.hls, location.href)).href : v.dataset.mp4);
    }).catch(function () { use(v.dataset.mp4); });
  }

  function init() {
    if (root.getAttribute('data-x99')) return;
    root.setAttribute('data-x99', '1');

    var targets = {
      product: document.getElementById('x99-reveal'),
      next: document.getElementById('x99-next')
    };

    /* hero buttons that scroll to a section instead of leaving the page */
    Array.prototype.forEach.call(document.querySelectorAll('[data-x99-scroll]'), function (a) {
      a.addEventListener('click', function (e) {
        var target = targets[a.getAttribute('data-x99-scroll')];
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    /* product reveal: zoom-settle the media and bring the text in once it scrolls into view */
    var reveal = document.querySelector('[data-x99-reveal]');
    if (reveal) {
      if (reduce || !('IntersectionObserver' in window)) reveal.classList.add('is-in');
      else {
        var rio = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { reveal.classList.add('is-in'); rio.disconnect(); }
        }, { threshold: 0.15 });
        rio.observe(reveal);
      }
    }

    /* stacked chapters: the card underneath sinks while the next one covers it */
    var chapters = Array.prototype.slice.call(document.querySelectorAll('.x99-chapter'));
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      chapters.forEach(function (c, i) {
        var next = chapters[i + 1];
        var q = 0;
        if (next) q = clamp(1 - next.getBoundingClientRect().top / vh, 0, 1);
        c.style.setProperty('--q', q.toFixed(3));
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    if (chapters.length > 1 && !reduce) {
      /* capture catches scrolling on the window and on Horizon's desktop .page-wrapper */
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    /* pinned sections (manifesto, reveal): --p (0 to 1) is how far through its scroll runway the section is */
    var manifestos = Array.prototype.slice.call(document.querySelectorAll('[data-x99="manifesto"], [data-x99="reveal"]'));
    if (manifestos.length && !reduce) {
      var mTicking = false;
      var updateManifestos = function () {
        mTicking = false;
        var vh = window.innerHeight;
        manifestos.forEach(function (m) {
          var r = m.getBoundingClientRect();
          var span = r.height - vh;
          var p = span > 0 ? clamp(-r.top / span, 0, 1) : 1;
          m.style.setProperty('--p', p.toFixed(4));
        });
      };
      var onManifestoScroll = function () { if (!mTicking) { mTicking = true; requestAnimationFrame(updateManifestos); } };
      document.addEventListener('scroll', onManifestoScroll, { passive: true, capture: true });
      window.addEventListener('resize', onManifestoScroll);
      updateManifestos();
    }

    /* collage: photos fade up once when the section scrolls into view */
    var collages = Array.prototype.slice.call(document.querySelectorAll('[data-x99="collage"]'));
    if (collages.length && !reduce && 'IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          cio.unobserve(en.target);
        });
      }, { threshold: 0.25 });
      collages.forEach(function (c) { c.setAttribute('data-live', ''); cio.observe(c); });
    }

    /* next-drop ledger: the row crossing the middle of the screen becomes .is-active (hover does the same in CSS) */
    var ledgers = Array.prototype.slice.call(document.querySelectorAll('.x99-ledger'));
    if (ledgers.length && !reduce && 'IntersectionObserver' in window) {
      ledgers.forEach(function (sec) {
        var rows = Array.prototype.slice.call(sec.querySelectorAll('.x99-ledger__item'));
        if (!rows.length) return;
        sec.setAttribute('data-live', '');
        var lio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) { en.target.classList.remove('is-active'); return; }
            rows.forEach(function (r) { r.classList.toggle('is-active', r === en.target); });
          });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        rows.forEach(function (r) { lio.observe(r); });
      });
    }

    /* Drop 02 survey: build the customer tags from the two picks on submit, block double sends */
    Array.prototype.forEach.call(document.querySelectorAll('form.x99-survey__form'), function (form) {
      form.addEventListener('submit', function () {
        var tags = ['drop02-survey'];
        var e = form.querySelector('input[name="x99_edition"]:checked');
        var c = form.querySelector('input[name="x99_colour"]:checked');
        if (e) tags.push('d02-edition-' + e.value);
        if (c) tags.push('d02-colour-' + c.value);
        var field = form.querySelector('[data-x99-tags]');
        if (field) field.value = tags.join(', ');
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
      });
    });

    /* background videos: no autoplay for reduced motion, pause while off-screen to save battery and data */
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[data-x99-video]'));
    if (videos.length) {
      if (matchMedia('(max-width: 749px)').matches) {
        videos.forEach(function (v) {
          if (v.dataset.posterMobile) v.poster = v.dataset.posterMobile;
          if (v.dataset.hls || v.dataset.mp4) pickMobileSource(v);
        });
      }
      if (reduce) {
        videos.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
      } else if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else v.pause();
          });
        }, { threshold: 0.05 });
        videos.forEach(function (v) { vio.observe(v); });
      }
    }

    /* optional countdown on the next-drop block */
    Array.prototype.forEach.call(document.querySelectorAll('[data-date]'), function (sec) {
      var t = Date.parse(sec.getAttribute('data-date'));
      var box = sec.querySelector('[data-x99-count]');
      if (!box || isNaN(t)) return;
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var s = Math.max(0, Math.floor((t - Date.now()) / 1000));
        if (s === 0) { box.innerHTML = '<span><b>Live</b><small>Now</small></span>'; clearInterval(timer); return; }
        var parts = [['Days', Math.floor(s / 86400)], ['Hrs', Math.floor(s % 86400 / 3600)], ['Min', Math.floor(s % 3600 / 60)], ['Sec', s % 60]];
        box.innerHTML = parts.map(function (p) { return '<span><b>' + pad(p[1]) + '</b><small>' + p[0] + '</small></span>'; }).join('');
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  try { ready(init); } catch (e) { /* never break the storefront */ }
})();
